import 'core-js/es/object/assign';
import 'core-js/es/object/entries';
import 'core-js/es/object/values';
import 'core-js/es/array/from';
import 'core-js/es/array/find';
import 'core-js/es/array/includes';
import 'core-js/es/promise';

import 'whatwg-fetch';

import 'custom-event-polyfill';

import mutationObs from 'mutation-observer';

window.MutationObserver = mutationObs;
